
import { computed, defineComponent, PropType } from 'vue'
import FormItem from '@/vue/ui/form/FormItem.vue'

export default defineComponent({
  name: 'FormInput',
  props: {
    modelValue: String as PropType<string>,
    placeholder: String as PropType<string>,
    label: String as PropType<string>,
    type: {
      type: String as PropType<string>,
      default: 'text',
      validate: (value: string) => ['text', 'number', 'email', 'password'].includes(value),
    },
    min: Number as PropType<number>,
    max: Number as PropType<number>,
    step: Number as PropType<number>,
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  components: {
    FormItem,
  },
  setup(props, { emit }) {
    const value = computed<string>({
      get: () => props.modelValue || '',
      set: (v: string) => emit('update:modelValue', v),
    })
    return { value }
  },
})
